<template>
  <el-row id="pdfDom">
    <section style="background-color: #0b0b0b;">
      <div class="flex flex-between">
        <div class="title-bc">
          <span v-if="!isDisabled">{{ detailReport.name }}</span>
          <el-input v-else v-model="detailReport.name" style="width: 400px" placeholder="请输入曲线名称" />
        </div>
        <div class="title-user" v-if="!notShowuser">
          {{ $t("m.deviceManage.deviceDetial.user") }}：{{ detailReport.username }}
        </div>
      </div>
      <div class="flex flex-center" style="margin:10px 0;flex-wrap: wrap;gap: 10px">
        <el-button type="primary" class="bt-large"
          >{{ $t("m.deviceManage.deviceDetial.roastDate")
          }}{{
            $moment(Number(detailReport.createtime)).format("YYYY-MM-DD")
          }}</el-button
        >
        <el-button type="primary" class="bt-large"
          ><el-rate
            :colors="['#FC9153', '#FC9153', '#FC9153']"
            v-model="detailReport.score"
            :disabled="!isDisabled"
          ></el-rate
        ></el-button>
        <el-button
          type="primary"
          class="bt-large bt-state-box"
          v-if="!iscollect"
          @click="addCollect"
        >
          <span class="bt-state bt-state-2"></span>
          {{ $t("m.deviceManage.deviceDetial.addCollect") }}
        </el-button>
        <el-button
          type="primary"
          class="bt-large bt-state-box"
          v-if="iscollect"
          @click="cancelCollect"
        >
          <span class="bt-state bt-state-2"></span>
          {{ $t("m.deviceManage.deviceDetial.cancelCollect") }}
        </el-button>
        <el-button
          type="primary"
          class="bt-large bt-state-box"
          v-if="!shared && role == 1"
          @click="shareReport"
        >
          <span class="bt-state bt-state-1"></span>
          {{ $t("m.deviceManage.deviceDetial.addRecommend") }}
        </el-button>
        <el-button
          type="primary"
          class="bt-large bt-state-box"
          v-if="shared && role == 1"
          @click="unShare"
        >
          <span class="bt-state bt-state-1"></span>
          {{ $t("m.deviceManage.deviceDetial.cancelRecommend") }}
        </el-button>
        <el-button type="primary" class="bt-large" @click="delCurve()" style="padding: 12px 20px">{{ $t("m.button.delete") }}</el-button>
        <el-button type="primary" v-if="!isDisabled" class="bt-large" @click="isDisabled = true" style="padding: 12px 20px">编辑</el-button>
        <el-button type="primary" v-if="isDisabled" class="bt-large" @click="savePort()" style="padding: 12px 20px">保存</el-button>
      </div>
      <div
        id="reportChart"
        style="height:500px;text-align:center;line-height:500px;width:calc(40vw - 30px);"
      ></div>
    </section>
    <section style="background-color: #0b0b0b;">
      <div class="flex flex-center header-common">
        <span class="header-span header-span-active">{{
          $t("m.deviceManage.deviceDetial.coffeeBeans")
        }}</span>
      </div>
      <div class="has-total-table"  id="hastable">
        <el-table
          :data="gridData1"
          border
          style="width:100%;"
          class="has-total-table"
          :empty-text="$t('m.options.deviceSearchOptions.noData')"
        >
          <el-table-column
            property="name"
            :label="$t('m.deviceManage.deviceDetial.cfName')"
          ></el-table-column>
          <el-table-column
            property="level"
            :label="$t('m.deviceManage.deviceDetial.cfLevel')"

          ></el-table-column>
          <el-table-column
            property="method"
            :label="$t('m.deviceManage.deviceDetial.cfOpreate')"
          ></el-table-column>
          <el-table-column
            property="createtime"
            :label="$t('m.deviceManage.deviceDetial.cfDate')"
  
          >
          <template slot-scope="scope">
            {{ $moment(Number(scope.row.createtime)).format("YYYY-MM-DD") }}
          </template>
          </el-table-column>
          <el-table-column
            property="weight"
            :label="
              $t('m.deviceManage.deviceDetial.cfWeight') +
                (weight == 'kg' ? '(kg)' : '(g)')
            "
       
          >
            <template slot-scope="scope">
              {{scope.row.weight?(scope.row.weight-0).toFixed(2):0.00}}
            </template>
          </el-table-column>
        </el-table>
        <div class="table-totla-line">
          <span class="gray-text"
            >{{ $t("m.deviceManage.deviceDetial.cfAllWeight")
            }}{{ weight == "kg" ? "(kg)" : "(g)" }}:</span
          >
          <span class="white-text">{{ this.totalweight?(this.totalweight-0).toFixed(2):0.00 }}</span>
        </div>
      </div>
    </section>
    <section style="background-color: #0b0b0b;">
      <div class="flex flex-center header-common">
        <span class="header-span header-span-active">
          {{ $t("m.quickEvent.describe") }}
        </span>
        <div v-if="showName" class="flex" style="margin-left:20px;">
          <span class="gray-text"
            >{{ $t("m.options.deviceSearchOptions.deviceName") }}：</span
          >
          <span class="white-text">{{
            desc.deviceName
          }}</span>
          <span class="gray-text"
            >{{ $t("m.options.deviceSearchOptions.deviceNumber") }}：</span
          >
          <span class="white-text">{{
            desc.type
          }}</span>
        </div>
      </div>
      <div class="row-box">
        <el-row>
          <el-col :span="12">
            <div class="flex flex-between">
              <span class="gray-text"
                >{{ $t("m.options.deviceSearchOptions.deviceNumber") }}：</span
              >
              <span class="white-text">{{ detailReport.deviceType || '无'}}</span>
            </div>
            <!--<div class="flex flex-between">
              <span class="gray-text">设备编号：</span>
              <span class="white-text">{{ desc.orino }}</span>
            </div>-->
          </el-col>
          <el-col :span="12">
            <div class="flex flex-between">
              <span class="gray-text"
                >{{ $t("m.options.deviceSearchOptions.seriesNumber") }}：</span
              >
              <span class="white-text">{{ detailReport.oriNo }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="flex flex-between">
              <span class="gray-text"
              >{{ $t("m.options.deviceSearchOptions.roastDuration") }}：
              </span>
              <span class="white-text">{{ timeFormatter(desc.hbtime) }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="flex flex-between">
              <span class="gray-text"
              >{{ $t("m.options.deviceSearchOptions.developmentTime") }}：
              </span>
              <span class="white-text">{{ timeFormatter(desc.devtime) }}</span>
            </div>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="flex flex-between">
              <span class="gray-text"
              >{{ $t("m.options.deviceSearchOptions.dropinTemp") }}：
              </span>
              <span class="white-text">{{ desc.tempera }}{{ temUnit }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="flex flex-between">
              <span class="gray-text"
              >{{ $t("m.options.deviceSearchOptions.developmentRate") }}：
              </span>
              <span class="white-text">{{ desc.devrate }}%</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="flex flex-between">
              <span class="gray-text"
              >{{ $t("m.options.deviceSearchOptions.turningPoint") }}：
              </span>
              <span class="white-text">{{ desc.hwd }}{{ temUnit }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="flex flex-between">
              <span class="gray-text"
              >{{ $t("m.options.deviceSearchOptions.yellowPoint") }}：
              </span>
              <span class="white-text">{{ desc.zhd }}{{ temUnit }}</span>
            </div>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="flex flex-between">
              <span class="gray-text"
              >{{ $t("m.options.deviceSearchOptions.firstCrack") }}：
              </span>
              <span class="white-text">{{ desc.yb }}{{ temUnit }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="flex flex-between">
              <span class="gray-text"
              >{{ $t("m.options.deviceSearchOptions.secondCrack") }}：
              </span>
              <span class="white-text">{{ desc.eb }}{{ temUnit }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="flex flex-between">
              <span class="gray-text"
              >{{ $t("m.options.deviceSearchOptions.end") }}：
              </span>
              <span class="white-text">{{ desc.end1 }}{{ temUnit }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="flex flex-between">
              <span class="gray-text"
              >{{ $t("m.options.deviceSearchOptions.RoR1") }}：
              </span>
              <span class="white-text">{{ desc.hwtohd }}{{ temUnit }}/min</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="flex flex-between">
              <span class="gray-text"
              >{{ $t("m.options.deviceSearchOptions.RoR2") }}：
              </span>
              <span class="white-text">{{ desc.hdtoyb }}{{ temUnit }}/min</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="flex flex-between">
              <span class="gray-text"
              >{{ $t("m.options.deviceSearchOptions.RoR3") }}：
              </span>
              <span class="white-text"
              >{{ desc.ybtoend }}{{ temUnit }}/min</span
              >
            </div>
          </el-col>
        </el-row>
      </div>
    </section>
    <section style="background-color: #0b0b0b;">
      <div class="flex flex-center header-common">
        <span class="header-span header-span-active"
          >{{ $t("m.options.deviceSearchOptions.process") }} </span
        ><!--<el-tag>{{temUnit}}</el-tag>-->
      </div>
      <el-table
        :data="tableLineList"
        ref="workforceTable"
        id="workForceTable"
        border
        style="width:100%;"
        :empty-text="$t('m.options.deviceSearchOptions.noData')"
      >
        <el-table-column
          property="hbTime"
          width="70px"
          :label="$t('m.table.time')"
        >
        <template #default="{ row }">
          {{ timeFormatter(row.hbTime) }}
        </template>
        </el-table-column>
        <el-table-column
          property="value"
          width="60px"
          :label="$t('m.deviceIndex.beanTemper') + '(' + temUnit + ')'"
        ></el-table-column>
        <el-table-column
          property="ror"
          width="80px"
          :label="`RoR (${temUnit}/min)`"
        ></el-table-column>
        <el-table-column
          property="rfw"
          width="70px"
          :label="$t('m.deviceIndex.inletAirTemperature') + '(' + temUnit + ')'"
        ></el-table-column>
        <el-table-column
          property="pfw"
          width="70px"
          :label="$t('m.deviceIndex.outWindTemper') + '(' + temUnit + ')'"
        ></el-table-column>
        <el-table-column
          property="hjw"
          width="70px"
          :label="$t('m.deviceIndex.environmentTemper') + '(' + temUnit + ')'"
        ></el-table-column>
        <el-table-column
          property="hot"
          width="60px"
          :label="$t('m.options.deviceSearchOptions.heat')"
        ></el-table-column>
        <el-table-column
          property="rf"
          width="60px"
          :label="$t('m.options.deviceSearchOptions.airflow')"
        ></el-table-column>
        <el-table-column
          property="gt"
          width="60px"
          :label="$t('m.options.deviceSearchOptions.drum')"
        ></el-table-column>
        <el-table-column
          property="mark"
          min-width="150px"
          :label="$t('m.options.deviceSearchOptions.mark')"
        ></el-table-column>
      </el-table>
    </section>
    <section id="exportSec">
      <div class="flex" style="justify-content:flex-end;margin-top:20px;">
        <div class="line-right">
          <el-button type="primary" @click="getPdf"
            >{{ $t("m.options.deviceSearchOptions.exportPdf") }}
          </el-button>
          <el-button v-if="role == 1" type="primary" @click="downLoadReport()"
            >{{ $t("m.options.deviceSearchOptions.exprotJSON") }}
          </el-button>
          <el-button type="primary" @click="downLoadLog()" v-if="isNewFileUrl && detailReport.logUrl"
          >{{ $t("m.button.exportLog") }}
        </el-button>
        </div>
      </div>
    </section>
  </el-row>
</template>

<script>
import { saveAs } from "file-saver";
import { getDwRorValue, getDwValue, getHJWValue, isValidDeviceInfo, getRfValue, getPFWValue, getRFWValue,getHotValue, getGtValue} from '../../utils/utils';
export default {
  props: {
    reportId: [String, Number],
    url: [String],
    showName: {
      type: Boolean,
      default: false,
    },
    notShowuser: {
      type: Boolean,
      default: false,
    },
    notDeviceno: {
      type: Boolean,
      default: false,
    },
    oriRecom: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    }
  },
  name: "report",
  data() {
    return {
      loading: undefined,
      desc: {
        serino: "无",
        tempera: 0,
        hwd: 0,
        yb: 0,
        eb: 0,
        devrate: 0,
        zhd: 0
      },
      usercompany: "",
      totalweight: 0,
      gridData1: [],
      temUnit: "℃",
      weight: "kg",
      detailReport: {},
      lineVoList: [],
      tableLineList: [],
      eventTable: [
        { tableData: [] },
        { tableData: [] },
        { tableData: [] },
        { tableData: [] },
        { tableData: [] },
      ],
      chartTypeOptions: [
        { value: 1, label: "豆表温度" },
        { value: 2, label: "热风温度" },
        { value: 3, label: "排风温度" },
        { value: 4, label: "环境温度" },
        { value: 5, label: "RoR" },
      ],
      fullscreenLoading: false,
      hbd: 80,
      rgb: "rgb(0,0,0)",
      textColor: "rgb(255,255,255)",
      activeChartType: 1,
      shared: false,
      iscollect: false,
      collectId: 0,
      role: 0,
      fileData: [],
      fileUrl: '',
      isNewFileUrl: true,
      coffeeData: {
          start: null,    // 入豆温
          huiWen: null,   // 回温
          yiBao: null,    // 一爆
          zhuanHuang: null, // 转黄
          erBao: null,    // 二爆
          hotCh: null,    // 调火力
          reFengCh: null, // 热风
          gtCh: null      // 滚筒
      },
      stateData: [],
      isDisabled: false
    };
  },
  mounted() {
    this.role = localStorage.role;
    console.log(this.url, this.isNew)
    if (!!this.url) {
      if (this.url.includes('.hb')) {
        this.isNewFileUrl = true;
        this.getReportDetail(this.reportId);
      } else {
        this.isNewFileUrl = false;
        this.getOldData(this.reportId);
      }
    } else {
      if (this.isNew) {
        this.isNewFileUrl = true;
        this.getReportDetail(this.reportId);
      } else {
        this.isNewFileUrl = false;
        this.getOldData(this.reportId);
      }
    }

    this.getDouTable();
    // this.checkShared(this.reportId);
    // this.checkCollect(this.reportId);
    this.temUnit = localStorage.temUnit;
    this.weight = localStorage.weight;
    // this.option.yAxis[0].name = this.temUnit;
    // this.option.yAxis[1].name = this.temUnit + "/Min";
  },
  methods: {
    shareReport() {
      let params;
      if (this.isNewFileUrl) {
        params = {
          curveId: this.reportId,
          reportId: -1,
          type: 0,
          status: true
        }
      } else {
        params = {
          curveId: -1,
          reportId: this.reportId,
          type: 0,
          status: true
        }
      }
      this.$http
        .post("/manage/curve/set/status", params)
        .then(resp => {
          if (resp.data) {
            this.shared = true;
            this.$message.success(this.$t("m.alert.updateSuccess"));
          }
        });
    },
    unShare() {
      let params;
      if (this.isNewFileUrl) {
        params = {
          curveId: this.reportId,
          reportId: -1,
          type: 0,
          status: false
        }
      } else {
        params = {
          curveId: -1,
          reportId: this.reportId,
          type: 0,
          status: false
        }
      }
      this.$http
        .post("/manage/curve/set/status", params)
        .then(
          function(resp) {
            this.$message.warning(
              this.$i18n.locale === "en-US"
                ? "Cancel recommended successfully"
                : "取消推荐成功"
            );
            if (resp.data) {
              this.shared = false;
            }
          }.bind(this)
        );
    },
    addCollect() {
      let params;
      if (this.isNewFileUrl) {
        params = {
          curveId: this.reportId,
          reportId: -1,
          type: 1,
          status: true
        }
      } else {
        params = {
          curveId: -1,
          reportId: this.reportId,
          type: 1,
          status: true
        }
      }
      this.$http
        .post("/manage/curve/set/status", params)
        .then(
          function(resp) {
            console.info(resp);
            this.$message.success(this.$t("m.alert.updateSuccess"));
            if (resp.data) {
              this.iscollect = true;
            }
          }.bind(this)
        );
    },
    cancelCollect() {
      let params;
      if (this.isNewFileUrl) {
        params = {
          curveId: this.reportId,
          reportId: -1,
          type: 1,
          status: false
        }
      } else {
        params = {
          curveId: -1,
          reportId: this.reportId,
          type: 1,
          status: false
        }
      }
      this.$http
        .post("/manage/curve/set/status", params)
        .then(
          function(resp) {
            console.info(resp);
            this.$message.warning(
              this.$i18n.locale === "en-US"
                ? "Cancel collection  successfully"
                : "取消收藏成功"
            );
            if (resp.data.success == true) {
              this.iscollect = false;
            }
          }.bind(this)
        );
    },
    chartTypeChange(type) {
      this.activeChartType = type;
    },
    rgbChange(val) {
      let actVal = (val / 100) * 255;
      let textVal = 255 - actVal;
      this.textColor = "rgb(" + textVal + "," + textVal + "," + textVal + ")";
    },
    temTrans(val) {
      //把摄氏度转为华氏度
      return ((val * 9) / 5 + 32).toFixed(2);
    },
    weightTrans(val) {
      //把kg转换成g
      return val * 1000;
    },
    hexToRgb(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      console.info("rgb" + result);
      this.hbd = parseInt((parseInt(result[1], 16) / 255) * 100) + 1;
      this.rgb = "#" + result[0];
      this.rgbChange(this.hbd);
    },
    getReportDetail(reportId) {
      if (reportId > 0) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
           background: "rgba(0, 0, 0, 0.7)",
        });
        this.loading = loading;
        this.$http
          .get(`/manage/curve/detail/${reportId}`)
          .then(
            resp => {
              this.detailReport = resp.data.data;
              this.fileUrl = resp.data.data.fileUrl;
              this.isNewFileUrl = true;
              console.log(resp.data.data);
              this.shared = resp.data.data.share;
              this.iscollect = resp.data.data.collect;
              this.fileHandle(this.fileUrl);
              loading.close();
              this.$emit("finish");
            }
          )
          .catch((err) => {
            loading.close();
          });
      }
    },
    initEventTable() {
      for (let index in this.lineVoList) {
        for (let len in this.lineVoList[index].points) {
          if(len==0){this.lineVoList[index].points[len].mark='开始烘焙'}
          if(len==this.lineVoList[index].points.length-1){this.lineVoList[index].points[len].mark='结束烘焙'}
          if (this.lineVoList[index].points[len].event != null) {
            this.eventTable[index].tableData.push({
              eventName: this.lineVoList[index].points[len].event.name,
              tempera: this.lineVoList[index].points[len].tempera,
            });
          }
        }
      }
    },
    timeFormatter(value) {
      const minutes = Math.floor(value / 60); // 计算分钟
      const secs = value % 60; // 计算剩余的秒数
      // 补零操作，确保分钟和秒数都是两位数
      const paddedMinutes = String(minutes).padStart(2, '0');
      const paddedSeconds = String(secs).padStart(2, '0');
      return `${paddedMinutes}:${paddedSeconds}`;
    },
    markzhuan(value) {
      if (value.indexOf("30秒标记点")>-1 || value == "结束标记点") {
        value = "";
      }
      return value;
    },
    downLoadReport() {
      this.$http
        .get("/manage/report/getAReportById.do", {
          params: {
            reportId: this.reportId,
          },
        })
        .then(
          function(resp) {
            let fileName = this.detailReport.name + ".json";
            saveAs(
              new Blob([JSON.stringify(resp.data.data)], {
                type: "",
              }),
              fileName
            );
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    async fileHandle(url) {
      try {
        const data = await this.downloadAndParseJson(url);
        this.dataHandle(data);
      } catch (error) {
        console.error('Failed to download or parse the file:', error);
      }
    },

    async downloadAndParseJson(fileUrl) {
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const text = await response.text();
      return JSON.parse(text);
    },

    dataHandle(data) {
      // console.log(data);
      if (!data) {
        return;
      }
      if (this.isNewFileUrl) {
        this.fileData = data
        .filter((item) => isValidDeviceInfo(item.deviceInfo))
        .map((item) => ({
          hbTime: item.hbTime,
          value: getDwValue(item.deviceInfo),
          keyPoint: item.keyPoint,
          timeFlag: item.timeFlag,
          ror: getDwRorValue(item.deviceInfo),
          hjw: getHJWValue(item.deviceInfo),
          rfw: getRFWValue(item.deviceInfo),
          pfw: getPFWValue(item.deviceInfo),
          rf: getRfValue(item.deviceInfo),
          hot: getHotValue(item.deviceInfo),
          gt: getGtValue(item.deviceInfo),
          mark: item?.remake || ''
        }));
        this.descHandle();
      } else {
        let minData = Math.min(...data.lineBeans.map(item => item.value));

        this.fileData = data.lineBeans.map(item => {
          return {
            value: item.value,         // 豆温
            hjw: item.value3,       // 环境温
            rfw: item.value1,       // 热风温
            pfw: item.value2,       // 排风温
            ror: item.rorData,      // 豆温ROR
            keyPoint: item.value === minData ? 'HuiWen' : '',
            hbTime: item.time,
            rf: item.reFen,
            hot: item.hotValue,
            gt: item.gunTongValue,
            mark: item.tag,
            stateType: item.stateType
          };
        });
        this.stateData = data.stateData;
        this.descHandle();
      }
      this.initChartNew();
      this.getProcessData();
    },

    initChartNew() {
    const chart = this.$echarts.init(document.getElementById('reportChart'));
    let fileData = this.fileData;

    // 提取 markPoint 数据
    const getMarkPoints = (dataField, color) => {
        let points = [];

        if (this.isNewFileUrl) {
            // 1. 提取关键点数据
            const targetKeyPoints = ['HuiWen', 'YiBao', 'ERBao', 'ZHuang', 'CUSTOM', 'HOTCH', 'REFENGCH', 'GTCH', ''];
            points = this.fileData
                .filter(item => targetKeyPoints.includes(item.keyPoint)) // 过滤出关键点数据
                .filter(item => item.hbTime !== 1) // 排除 hbTime 为 1 的点
                .sort((a, b) => a.hbTime - b.hbTime); // 按 hbTime 排序
        } else {
            // 1. 过滤 stateData，保留 time > 0 的数据
            const validStateData = this.stateData.filter(item => item.time > 0);
            // 2. 提取与 stateData 中 time 匹配的 fileData 数据
            const matchedData = this.fileData.filter(dataItem =>
                validStateData.some(stateItem => stateItem.time === dataItem.hbTime)
            );
            // 3. 提取 stateType 为 6 或 7 的数据
            const stateTypeData = this.fileData.filter(item => item.stateType === 6 || item.stateType === 7);
            // 4. 合并匹配数据和 stateType 为 6 或 7 的数据
            const combinedData = [...matchedData, ...stateTypeData];
            // 5. 去重：使用 Set 去除 hbTime 重复的数据
            const uniqueData = Array.from(new Set(combinedData.map(item => item.hbTime)))
                .map(hbTime => combinedData.find(item => item.hbTime === hbTime));
            // 6. 按 hbTime 排序
            points = uniqueData
                .filter(item => item.hbTime !== 1) // 排除 hbTime 为 1 的点
                .sort((a, b) => a.hbTime - b.hbTime);
        }

        // 将过滤后的数据转换为 markPoint 格式
        return points.map(item => ({
            name: item.keyPoint || item.stateType, // 使用 keyPoint 或 stateType 作为名称
            coord: [String(item.hbTime), item[dataField]], // 坐标：x 为 hbTime，y 为动态字段
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
                color: color, // 使用曲线的颜色
            },
            label: {
                show: false, // 不显示标签
            },
        }));
    };
    // ECharts 配置
        // 获取除 RoR 以外的所有曲线的数据
        const seriesData = [
            this.fileData.map((item) => item.value),  // beanTemper
            this.fileData.map((item) => item.hjw),    // environmentTemper
            this.fileData.map((item) => item.rfw),    // inletAirTemperature
            this.fileData.map((item) => item.pfw)     // outWindTemper
        ];

        // 找到所有曲线的最低点和最高点
        let minValue = Infinity;
        let maxValue = -Infinity;

        seriesData.forEach(data => {
            const currentMin = Math.min(...data);
            const currentMax = Math.max(...data);

            if (currentMin < minValue) {
                minValue = currentMin;
            }

            if (currentMax > maxValue) {
                maxValue = currentMax;
            }
        });
        // 将 minValue 和 maxValue 转换为最接近的 5 的倍数
        const roundToNearest5 = (value, direction) => {
            if (direction === 'floor') {
                return Math.floor(value / 5) * 5; // 向下取整到 5 的倍数
            } else if (direction === 'ceil') {
                return Math.ceil(value / 5) * 5; // 向上取整到 5 的倍数
            }
            return value;
        };

        const yAxisMin = roundToNearest5(minValue - 50, 'floor'); // 最低点向下取整到 5 的倍数并减去 50
        const yAxisMax = roundToNearest5(maxValue + 50, 'ceil');  // 最高点向上取整到 5 的倍数并加上 50

        const option = {
            title: {
                text: "",
            },
            dataZoom: [
                {
                    type: "inside", // x轴
                    xAxisIndex: 0,
                    zoomOnMouseWheel: true, // 鼠标滚轮触发缩放
                },
            ],
            tooltip: {
                trigger: "axis",
                formatter: function (params) {
                    let tooltipContent = '<div style="text-align: left;">'; // 左对齐容器
                    const timeInSeconds = params[0].axisValue; // 时间值（秒）
                    const minutes = Math.floor(timeInSeconds / 60); // 转换为分钟
                    const seconds = timeInSeconds  % 60; // 剩余的秒数
                    const formattedTime = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`; // 格式化为 MM:SS

                    tooltipContent += `时间: ${formattedTime}<br/>`;

                    params.forEach(param => {
                        // 添加颜色圆点
                        tooltipContent += `<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;background-color:${param.color};"></span>`;
                        tooltipContent += `${param.seriesName}: ${param.value}<br/>`;
                    });

                    tooltipContent += '</div>'; // 结束容器
                    return tooltipContent;
                },
            },
            color: ["#FC9153", "#819C03", "#FF5A51", "#6AAAFF" ,"#FFFFFF"], // 曲线颜色列表
            legend: {
                icon: "circle",
                data: [
                    this.$t("m.deviceIndex.beanTemper"),
                    this.$t("m.deviceIndex.inletAirTemperature"),
                    this.$t("m.deviceIndex.outWindTemper"),
                    this.$t("m.deviceIndex.environmentTemper"),
                    "RoR",
                ],
                textStyle: {
                    color: "#B4CEFF",
                    fontSize: "12",
                },
            },
            grid: {
                left: "1%",
                right: "1%",
                bottom: "1%",
                containLabel: true,
            },
            toolbox: {
                feature: {},
            },
            xAxis: {
                name: "",
                type: "category",
                boundaryGap: false,
                axisLine: {
                    lineStyle: {
                        color: "#CED1D6",
                    },
                },
                axisLabel: {
                    interval: (() => {
                        const fileDataLength = this.fileData.length; // 获取 fileData 的长度

                        if (fileDataLength > 24 * 60) {
                            return 179; // 如果数据长度 > 36 小时，间隔为 59 * 3
                        } else if (fileDataLength <= 24 * 60 && fileDataLength > 12 * 60) {
                            return 119; // 如果数据长度 > 24 小时，间隔为 118
                        } else {
                            return 59; // 默认间隔为 59
                        }
                    })(),
                    formatter: function (value) {
                        var secondTime = parseInt(value); // 秒
                        var minuteTime = 0; // 分
                        var hourTime = 0; // 小时
                        var result = secondTime;
                        if (secondTime >= 60) {
                            minuteTime = parseInt(secondTime / 60); // 计算分钟
                            secondTime = parseInt(secondTime % 60); // 计算剩余秒
                            if (minuteTime >= 60) {
                                hourTime = parseInt(minuteTime / 60); // 计算小时
                                minuteTime = parseInt(minuteTime % 60); // 计算剩余分钟
                            }
                        }
                    
                        // 时间格式化为 MM:SS 或 HH:MM:SS
                        if (secondTime < 10) {
                            result = "0" + secondTime;
                        } else {
                            result = String(secondTime);
                        }
                        if (minuteTime > 0) {
                            result = `${minuteTime < 10 ? "0" + minuteTime : minuteTime}:${result}`;
                        }
                        if (hourTime > 0) {
                            result = `${hourTime < 10 ? "0" + hourTime : hourTime}:${result}`;
                        }
                        if (result == '00') {
                            result = '00:00'
                        }
                        return result;
                    },
                },
                data: (() => {
                  const fileDataLength = this.fileData.length; // 获取 fileData 的长度
                  const hours6 = 6 * 60;
                  const hours12 = 12 * 60;
                  const hours18 = 18 * 60;
                  const hours24 = 24 * 60;

                  let maxTime = hours6; 

                  if (fileDataLength <= hours6) {
                      maxTime = hours6;
                  } else if (fileDataLength <= hours12 && fileDataLength > hours6) {
                      maxTime = hours12;
                  } else if (fileDataLength <= hours18 && fileDataLength > hours12) {
                      maxTime = hours18;
                  } else if (fileDataLength <= hours24 && fileDataLength > hours18) {
                      maxTime = hours24;
                  } else if (fileDataLength > hours24) {
                      maxTime = 30 * 60;
                  }

                  // 生成从 0 到 maxTime 的数组
                  return Array.from({ length: maxTime + 1 }, (_, index) => index);
                })(),
            },
            yAxis: [
                {
                    name: "(℃)",
                    type: "value",
                    min: yAxisMin, // 动态设置最小值
                    max: yAxisMax, // 动态设置最大值
                    axisLine: {
                        lineStyle: {
                            color: "#CED1D6",
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: "rgba(82, 47, 47, 1)",
                        },
                    },
                    interval: 25,
                },
                {
                    name: "(℃/min)",
                    type: "value",
                    axisLine: {
                        lineStyle: {
                            color: "#CED1D6",
                        },
                    },
                    min: 0, // 最小值为 0
                    max: 30, // 最大值为 30
                    interval: 5, // 间隔为 5
                    splitLine: {
                        show: false,
                        lineStyle: {
                            color: "rgba(82, 47, 47, 1)",
                        },
                    },
                },
            ],
            series: [
                {
                    name: this.$t("m.deviceIndex.beanTemper"),
                    smooth: true,
                    symbol: 'none',
                    type: "line",
                    data: fileData.map((item) => item.value), // 数据按每秒显示
                    markPoint: {
                        data: getMarkPoints('value', '#FC9153'), // 使用 value 字段和对应颜色
                    },
                },
                {
                    name: this.$t("m.deviceIndex.environmentTemper"),
                    smooth: true,
                    type: "line",
                    symbol: 'none',
                    data: fileData.map((item) => item.hjw), // 使用 hjw 作为数据
                    markPoint: {
                        data: getMarkPoints('hjw', '#819C03'), // 使用 hjw 字段和对应颜色
                    },
                },
                {
                    name: this.$t("m.deviceIndex.inletAirTemperature"),
                    smooth: true,
                    type: "line",
                    symbol: 'none',
                    data: fileData.map((item) => item.rfw), // 使用 rfw 作为数据
                    markPoint: {
                        data: getMarkPoints('rfw', '#FF5A51'), // 使用 rfw 字段和对应颜色
                    },
                },
                {
                    name: this.$t("m.deviceIndex.outWindTemper"),
                    smooth: true,
                    type: "line",
                    symbol: 'none',
                    data: fileData.map((item) => item.pfw), // 使用 Pfw 作为数据
                    markPoint: {
                        data: getMarkPoints('pfw', '#6AAAFF'), // 使用 pfw 字段和对应颜色
                    },
                },
                {
                    name: "RoR",
                    smooth: true,
                    yAxisIndex: 1, // 使用第二个 Y 轴
                    symbol: 'none',
                    type: "line",
                    data: fileData.map((item) => item.ror), // 直接使用 ror 的值
                },
            ],
        };
        chart.setOption(option);
    },
    descHandle() {
      const minutes = Math.floor(this.fileData.length / 60); // 计算分钟
      const seconds = this.fileData.length % 60; // 计算剩余的秒数
      this.desc.hbtime = this.fileData.length;
    
      if (this.isNewFileUrl) {
        this.fileData.forEach(item => {
        switch (item.keyPoint) {
            case 'START':
                this.coffeeData.start = {
                    time: item?.hbTime || 0,
                    temperature: item.value
                };
                break;
            case 'HuiWen':
                this.coffeeData.huiWen = {
                    time: item?.hbTime || 0,
                    temperature: item.value
                };
                break;
            case 'YiBao':
                this.coffeeData.yiBao = {
                    time: item?.hbTime || 0,
                    temperature: item.value
                };
                break;
            case 'ZHuang':
                this.coffeeData.zhuanHuang = {
                    time: item?.hbTime || 0,
                    temperature: item.value
                };
                break;
            case 'ERBao':
                this.coffeeData.erBao = {
                    time: item?.hbTime || 0,
                    temperature: item.value
                };
                break;
            case 'HOTCH':
                this.coffeeData.hotCh = {
                    time: item?.hbTime || 0,
                    temperature: item.value
                };
                break;
            case 'REFENGCH':
                this.coffeeData.reFengCh = {
                    time: item?.hbTime || 0,
                    temperature: item.value
                };
                break;
            case 'GTCH':
                this.coffeeData.gtCh = {
                    time: item?.hbTime || 0,
                    temperature: item.value
                };
                break;
            default:
                break;
            }
        });
        this.desc.tempera =  this.coffeeData.start && this.coffeeData.start.temperature >= 0 ? `${this.timeFormatter(this.coffeeData.start.time)}/${this.coffeeData.start.temperature}` : '--'; // 入豆温
        this.desc.hwd = this.coffeeData.huiWen && this.coffeeData.huiWen.temperature >= 0 ? `${this.timeFormatter(this.coffeeData.huiWen.time)}/${this.coffeeData.huiWen.temperature}` : '--';    //回温点
        this.desc.yb = this.coffeeData.yiBao && this.coffeeData.yiBao.temperature >= 0 ? `${this.timeFormatter(this.coffeeData.yiBao.time)}/${this.coffeeData.yiBao.temperature}` : '--';  //一爆
        this.desc.eb = this.coffeeData.erBao && this.coffeeData.erBao.temperature >= 0 ? `${this.timeFormatter(this.coffeeData.erBao.time)}/${this.coffeeData.erBao.temperature}` : '--'; // 二爆
        this.desc.zhd = this.coffeeData.zhuanHuang && this.coffeeData.zhuanHuang.temperature >= 0 ? `${this.timeFormatter(this.coffeeData.zhuanHuang.time)}/${this.coffeeData.zhuanHuang.temperature}` : '--'; // 转黄点
        this.desc.end1 = `${this.timeFormatter(this.fileData[this.fileData.length - 1]?.hbTime)}/${this.fileData[this.fileData.length - 1]?.value}`;// 结束
     
        // 1. 回温点至转黄点的温升
        this.desc.hwtohd = this.calculateRiseRate(
            this.coffeeData.huiWen?.temperature || 0,
            this.coffeeData.zhuanHuang?.temperature || 0,
            this.coffeeData.huiWen?.time || 0,
            this.coffeeData.zhuanHuang?.time || 0
        );

        // 2. 黄点至一爆的温升
        this.desc.hdtoyb = this.calculateRiseRate(
            this.coffeeData.zhuanHuang?.temperature || 0,
            this.coffeeData.yiBao?.temperature || 0,
            this.coffeeData.zhuanHuang?.time || 0,
            this.coffeeData.yiBao?.time || 0
        );

        // 3. 一爆至结束的温升
        this.desc.ybtoend = this.calculateRiseRate(
            this.coffeeData.yiBao?.temperature || 0,
            this.fileData[this.fileData.length - 1].value,
            this.coffeeData.yiBao?.time || 0,
            this.fileData[this.fileData.length - 1].hbTime
        );
        this.desc.devtime = this.fileData[this.fileData.length - 1].hbTime - this.coffeeData.yiBao?.time || 0;
        this.desc.devrate = ((this.desc.devtime / this.fileData[this.fileData.length - 1].hbTime) * 100).toFixed(2);
      } else {
        let timeData = {
          tempera: 0,
          hwd: 0,
          zhd: 0,
          yb: 0,
          eb: 0,
        }
        this.stateData.forEach(item => {
          switch (item.type) {
            case 0:
                this.desc.tempera = item && item.value >= 0 ? `${this.timeFormatter(item.time)}/${item.value}` : '--';
                timeData.tempera = item.time || 0;
                break;
            case 2:
                this.desc.hwd = item && item.value >= 0 ? `${this.timeFormatter(item.time)}/${item.value}` : '--';
                timeData.hwd = item.time || 0;
                break;
            case 3:
                this.desc.zhd = item && item.value >= 0 ? `${this.timeFormatter(item.time)}/${item.value}` : '--';
                timeData.zhd = item.time || 0;
                break;
            case 4:
                this.desc.yb = item && item.value >= 0 ? `${this.timeFormatter(item.time)}/${item.value}` : '--';
                timeData.yb = item.time || 0;
                break;
            case 5:
                this.desc.eb = item && item.value >= 0 ? `${this.timeFormatter(item.time)}/${item.value}` : '--';
                timeData.eb = item.time || 0;
                break;
            default:
                break;
            }
        });
        this.desc.end1 = `${this.timeFormatter(this.fileData[this.fileData.length - 1]?.hbTime)}/${this.fileData[this.fileData.length - 1]?.value}`;// 结束
        this.desc.hwtohd = this.calculateRiseRate(this.desc.hwd, this.desc.zhd, timeData.hwd, timeData.zhd);
        this.desc.hdtoyb = this.calculateRiseRate(this.desc.zhd, this.desc.yb, timeData.zhd, timeData.yb);
        this.desc.ybtoend = this.calculateRiseRate(this.desc.yb, this.fileData[this.fileData.length - 1].value, timeData.yb, this.fileData[this.fileData.length - 1].hbTime);
        this.desc.devtime = this.fileData[this.fileData.length - 1].hbTime - timeData.yb || 0;
        this.desc.devrate = ((this.desc.devtime / this.fileData[this.fileData.length - 1].hbTime) * 100).toFixed(2);
      }
        
    },
        // 计算温升
    calculateRiseRate(startTemp, endTemp, startTime, endTime) {
      // 校验输入值
      const isValid = (value) => typeof value === 'number' && value >= 0;
      if (!isValid(startTemp) || !isValid(endTemp) || !isValid(startTime) || !isValid(endTime)) {
          return 0;
      }

      const timeDiff = (endTime - startTime) / 60; // 将秒转换为分钟
      if (timeDiff <= 0) {
          return 0; // 时间差为 0 或负数时，返回 0
      }
      return ((endTemp - startTemp) / timeDiff).toFixed(2);
    },
    getDouTable() {
      this.$http.get(`/manage/curve/record/bean?id=${this.reportId}`).then(res => {
        if (res.data) {
          this.gridData1 = res.data.data;
          this.totalweight = res.data.data.reduce((sum, item) => {
              return sum + (item.weight || 0); // 如果 weight 为 null 或 undefined，则默认为 0
          }, 0);
        }
      })
    },
    getProcessData() {
      if (this.isNewFileUrl) {
          // 1. 提取关键点数据
          const keyPointData = this.fileData.filter(item => item.keyPoint !== 'Non' || (item.keyPoint === 'Non' && item.timeFlag));
          // 2. 提取每 30 秒一次的数据
          const interval = 30; // 30 秒
          const timeSet = new Set(); // 用于去重
          const intervalData = this.fileData.filter(item => {
              if (item.hbTime % interval === 0 && !timeSet.has(item.hbTime)) {
                  timeSet.add(item.hbTime); // 记录已添加的时间
                  return true;
              }
              return false;
          });
          const endData = this.fileData[this.fileData.length - 1];
          // 3. 合并关键点数据和每 30 秒数据
          const combinedData = [...keyPointData, ...intervalData, endData];
          // 4. 去重：使用 Set 去除 hbTime 重复的数据
          const uniqueData = Array.from(new Set(combinedData.map(item => item.hbTime)))
              .map(hbTime => combinedData.find(item => item.hbTime === hbTime));
          // 5. 按 hbTime 排序
          this.tableLineList = uniqueData.sort((a, b) => a.hbTime - b.hbTime);
      } else {
          // 1. 过滤 stateData，保留 time > 0 的数据
          const validStateData = this.stateData.filter(item => item.time > 0);
          // 2. 提取与 stateData 中 time 匹配的 fileData 数据
          const matchedData = this.fileData.filter(dataItem =>
              validStateData.some(stateItem => stateItem.time === dataItem.hbTime)
          );
          // 3. 提取每 30 秒一次的数据
          const interval = 30; // 30 秒
          const timeSet = new Set(); // 用于去重
          const intervalData = this.fileData.filter(item => {
              if (item.hbTime % interval === 0 && !timeSet.has(item.hbTime)) {
                  timeSet.add(item.hbTime); // 记录已添加的时间
                  return true;
              }
              return false;
          });
          // 4. 提取 stateType 为 6 或 7 的数据
          const stateTypeData = this.fileData.filter(item => item.stateType === 6 || item.stateType === 7);
          // 5. 合并匹配数据、每 30 秒数据和 stateType 为 6 或 7 的数据
          const endData = this.fileData[this.fileData.length - 1];
          const combinedData = [...matchedData, ...intervalData, ...stateTypeData, endData];
          // 6. 去重：使用 Set 去除 hbTime 重复的数据
          const uniqueData = Array.from(new Set(combinedData.map(item => item.hbTime)))
              .map(hbTime => combinedData.find(item => item.hbTime === hbTime));
          // 7. 按 hbTime 排序
          this.tableLineList = uniqueData.sort((a, b) => a.hbTime - b.hbTime);
      }
    },
    getOldData(reportId) {
      if (reportId > 0) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
           background: "rgba(0, 0, 0, 0.7)",
        });
        this.loading = loading;
        this.$http
          .get(`/manage/report/getAReportById.do?reportId=${reportId}`)
          .then(
            resp => {      
              const data = resp.data.data;
              this.detailReport = {
                createtime: data.createtime,
                name: data.name,
                score: Number(data.level),
                deviceType: data.suitVo?.deviceType,
                oriNo: data.suitVo?.device.orino,
                username: data.suitVo?.user.name || '--'
              }
              console.log(data);
              this.shared = data.share;
              this.iscollect = data.collect;
              const url = `https://hb-coffee-image.oss-cn-hangzhou.aliyuncs.com/cf_data/${data.suitVo.user.id}/${data.note}`
              this.fileHandle(url);
              loading.close();
              this.$emit("finish");
            }
          )
          .catch((err) => {
            loading.close();
          });
      }
    },
    delCurve() {
      const params = [this.reportId];
      this.$confirm("确定要删除此条曲线吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http.post('/manage/curve/delete', params).then(res => {
        this.$emit('curve-deleted', this.reportId);
      })
      })
    },
    downLoadLog() {
      if (this.detailReport && this.detailReport.logUrl) {
        fetch(this.detailReport.logUrl)
        .then(response => response.blob()) // 将响应转换为 Blob
        .then(blob => {
          saveAs(blob, this.detailReport.logUrl.split('/').pop()); // 使用 FileSaver.js 下载文件
        })
        .catch(error => {
          console.error('Error downloading the file', error);
        });
      } else {
        console.error('Log URL is not available');
      }
    },
    savePort() {
      const params = {curveId: this.reportId, name: this.detailReport.name, score: this.detailReport.score};
      this.$http.post('/manage/curve/update', params).then(res => {
        if (res.data.success) {
          this.$message.success(this.$t("m.alert.changeSuccess"));
          this.isDisabled = true;
        } else {
          this.$message.error(this.$t("m.alert.changeError"));
        }
      
      }).catch(err => {
        console.log(err);
      })
    }
  },
};
</script>
<style scoped>
.el-button+.el-button {
 margin: 0;
}
.line-right {
  display: flex;
  gap: 10px
}
</style>